<template>
  <div class="banner _clearboth hide-sm mt-0">
    <div class="container">
      <ul class="banner__list">
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Banner'
  }
</script>



// WEBPACK FOOTER //
// Banner.vue?0170667f